<template>
  <div>
    <div class="project-header">
      <button class="back-btn" @click="router.visit('/')">← Projects</button>
      <div class="project-meta">
        <span class="project-name">{{ project.name }}</span>
        <span class="adapter-badge">{{ project.rag_adapter }}</span>
        <span class="project-uuid">{{ project.uuid }}</span>
      </div>
    </div>
    <nav class="tab-bar">
      <button
        v-for="tab in tabs"
        :key="tab.href"
        class="tab-pill"
        :class="{ active: isActive(tab.href) }"
        @click="router.visit(tab.href)"
      >
        {{ tab.label }}
      </button>
    </nav>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { router, usePage } from "@inertiajs/vue3"

const props = defineProps({
  project: { type: Object, required: true },
})

const page = usePage()

const tabs = computed(() => [
  { label: "OVERVIEW",  href: `/projects/${props.project.uuid}` },
  { label: "PIPELINE",  href: `/projects/${props.project.uuid}/pipeline` },
  { label: "RAG",       href: `/projects/${props.project.uuid}/rag` },
  { label: "EVAL",      href: `/projects/${props.project.uuid}/eval` },
  { label: "TEST",      href: `/projects/${props.project.uuid}/test` },
  { label: "LEARNING",  href: `/projects/${props.project.uuid}/learning` },
  { label: "FINETUNE",  href: `/projects/${props.project.uuid}/finetune` },
  { label: "WEBHOOKS",  href: `/projects/${props.project.uuid}/webhooks` },
  { label: "SETTINGS",  href: `/projects/${props.project.uuid}/settings` },
])

function isActive(href) {
  return page.url === href || page.url.startsWith(`${href}?`)
}
</script>

<style scoped>
.project-header {
  padding: 14px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-btn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  color: rgba(232, 230, 227, 0.45);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s;
  white-space: nowrap;
}

.back-btn:hover {
  color: #f5a623;
}

.project-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.project-name {
  font-family: var(--font-display);
  font-size: 16px;
  font-weight: 700;
  color: #e8e6e3;
}

.adapter-badge {
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 3px;
  background: rgba(245, 166, 35, 0.18);
  color: #f5a623;
}

.project-uuid {
  font-family: var(--font-mono);
  font-size: 10px;
  color: rgba(232, 230, 227, 0.25);
}

.tab-bar {
  display: flex;
  padding: 0 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  gap: 2px;
}

.tab-pill {
  padding: 10px 14px;
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  color: rgba(232, 230, 227, 0.45);
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: -1px;
}

.tab-pill:hover {
  color: #e8e6e3;
}

.tab-pill.active {
  color: #f5a623;
  background: rgba(245, 166, 35, 0.12);
  border-bottom-color: #f5a623;
}
</style>
